const lengthWithoutSpaces = (string) => string ? string.replace(/\s/g, '').length : 0;

export default lengthWithoutSpaces;
